'use client';

import { type ReactNode } from 'react';
import { SortFilterOverlayProvider } from '../cms-blocks/SortAndFilterPanel/SortFilterOverlayContext';
import { EmailCaptureProvider } from './EmailCapture';

/**
 * The client-side feature providers cms-components needs, in one place.
 *
 * Mount it once inside `CmsClientProvider`. New features add their provider
 * here, so consumers never have to touch their own tree again — and because
 * every feature hook tolerates its provider being absent, mounting this is
 * optional for consumers that do not use those features (stories, tests).
 */
export const CmsFeaturesProvider = ({ children }: { children: ReactNode }) => (
  <EmailCaptureProvider>
    <SortFilterOverlayProvider>{children}</SortFilterOverlayProvider>
  </EmailCaptureProvider>
);
